/**
 * ISO 3166-2 Subdivision Codes für deutsche Bundesländer / Stadtstaaten.
 * Wird u. a. für Schulferien (OpenHolidays) und Trainingsregion genutzt.
 */
export const GERMAN_TRAINING_SUBDIVISION_CODES = Object.freeze([
  "DE-BW",
  "DE-BY",
  "DE-BE",
  "DE-BB",
  "DE-HB",
  "DE-HH",
  "DE-HE",
  "DE-MV",
  "DE-NI",
  "DE-NW",
  "DE-RP",
  "DE-SL",
  "DE-SN",
  "DE-ST",
  "DE-SH",
  "DE-TH",
]);

export function isGermanTrainingSubdivision(code) {
  const c = String(code ?? "").trim();
  return GERMAN_TRAINING_SUBDIVISION_CODES.includes(c);
}
